import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Icons
import { IoInformationCircle } from "react-icons/io5";

// Mytherra API
import mytherraApi from "services/mytherraApi";

function AboutWallet() {
  const [walletInfo, setWalletInfo] = useState(null);
  const [blockchainInfo, setBlockchainInfo] = useState(null);

  useEffect(() => {
    fetchWalletInfo();
  }, []);

  const fetchWalletInfo = async () => {
    try {
      const wallet = await mytherraApi.getWalletInfo();
      const blockCount = await mytherraApi.getBlockCount();
      
      setWalletInfo(wallet);
      setBlockchainInfo({ blocks: blockCount });
    } catch (error) {
      console.error("Error fetching wallet info:", error);
    }
  };

  return (
    <Card>
      <VuiBox p={3}>
        <VuiBox mb={3}>
          <VuiBox display="flex" alignItems="center" mb={1}>
            <VuiBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="48px"
              height="48px"
              borderRadius="12px"
              sx={{ background: "#00CED1" }}
              mr={2}
            >
              <IoInformationCircle size="24px" color="#000000" />
            </VuiBox>
            <VuiTypography variant="lg" color="white" fontWeight="bold">
              About Wallet
            </VuiTypography>
          </VuiBox>
          <VuiTypography variant="button" color="text" ml={7}>
            Wallet and blockchain information
          </VuiTypography>
        </VuiBox>

        {/* Wallet Version */}
        <VuiBox mb={2} p={2} sx={{ background: "rgba(255, 255, 255, 0.02)", borderRadius: "8px" }}>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center">
            <VuiTypography variant="button" color="text">
              Wallet Version
            </VuiTypography>
            <VuiTypography variant="button" color="white" fontWeight="bold">
              1.0.0
            </VuiTypography>
          </VuiBox>
        </VuiBox>

        {/* Node Version */}
        <VuiBox mb={2} p={2} sx={{ background: "rgba(255, 255, 255, 0.02)", borderRadius: "8px" }}>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center">
            <VuiTypography variant="button" color="text">
              Node Version
            </VuiTypography>
            <VuiTypography variant="button" color="white" fontWeight="bold">
              {walletInfo?.version || "Loading..."}
            </VuiTypography>
          </VuiBox>
        </VuiBox>

        {/* Wallet Name */}
        <VuiBox mb={2} p={2} sx={{ background: "rgba(255, 255, 255, 0.02)", borderRadius: "8px" }}>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center">
            <VuiTypography variant="button" color="text">
              Wallet Name
            </VuiTypography>
            <VuiTypography variant="button" color="white" fontWeight="bold">
              {walletInfo?.walletname || "Default Wallet"}
            </VuiTypography>
          </VuiBox>
        </VuiBox>

        {/* Current Block */}
        <VuiBox mb={3} p={2} sx={{ background: "rgba(255, 255, 255, 0.02)", borderRadius: "8px" }}>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center">
            <VuiTypography variant="button" color="text">
              Current Block Height
            </VuiTypography>
            <VuiTypography variant="button" color="white" fontWeight="bold">
              {blockchainInfo?.blocks?.toLocaleString() || "Loading..."}
            </VuiTypography>
          </VuiBox>
        </VuiBox>

        {/* Info Box */}
        <VuiBox p={2} sx={{ background: "linear-gradient(135deg, rgba(0, 117, 121, 0.2) 0%, rgba(75, 23, 126, 0.2) 100%)", borderRadius: "8px", border: "1px solid rgba(0, 206, 209, 0.2)" }}>
          <VuiBox display="flex" alignItems="flex-start" mb={2}>
            <Icon sx={{ color: "#00CED1", fontSize: "20px", mr: 1 }}>
              info
            </Icon>
            <VuiBox>
              <VuiTypography variant="button" color="white" fontWeight="bold">
                Mytherra Blockchain
              </VuiTypography>
              <VuiTypography variant="caption" color="text" display="block" mt={0.5}>
                A decentralized cryptocurrency built for the future
              </VuiTypography>
            </VuiBox>
          </VuiBox>
          
          <VuiBox>
            <VuiTypography variant="caption" color="text" display="block" mb={0.5}>
              <strong style={{ color: "#00CED1" }}>Website:</strong> mytherrablockchain.org
            </VuiTypography>
            <VuiTypography variant="caption" color="text" display="block" mb={0.5}>
              <strong style={{ color: "#00CED1" }}>Explorer:</strong> explorerspace.mytherrablockchain.org
            </VuiTypography>
            <VuiTypography variant="caption" color="text" display="block">
              <strong style={{ color: "#00CED1" }}>GitHub:</strong> github.com/MYTHERRA
            </VuiTypography>
          </VuiBox>
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

export default AboutWallet;
